import WorklistsPage from "@/pages/worklists/WorklistsPage.tsx";
import { createFileRoute } from "@tanstack/react-router";

/**
 * Worklists route definition
 */

export const Route = createFileRoute("/worklists")({
  component: WorklistsPage,
});
